import React from 'react';

import {CopyButton} from 'src/components/copy-button/copy-button';
import {Separator} from 'src/components/separator';
import {FieldReviewList} from 'src/modules/ai/change-request-review/review-feedback/view/field-review-list';
import {FieldReview} from 'src/openapi/models/FieldReview';
import {camelToSnakeCase} from 'src/utils/camelToSnakeCase';

import {Popover} from '@pb/kit-component-dropdown-v2';
import {Group, Item} from '@pb/kit-component-group';
import {Icon, Icons, Sizes} from '@pb/kit-component-icon';

type Props = {
    field: FieldReview,
    verticalOffset?: number,
};

const DEFAULT_SUMMARY = 'No summary provided.';

export const ReviewFeedback = (props: Props) => {
    const {field, verticalOffset} = props;

    const risks = field.risks || [];
    const recommendations = field.recommendations || [];
    const summary = field.summary || DEFAULT_SUMMARY;
    const fieldName = field.fieldName;

    const hasRisksOrRecommendations = Boolean(risks.length > 0 || recommendations.length > 0);

    return (
        <>
            {hasRisksOrRecommendations ? (
                <Popover
                    verticalOffset={verticalOffset}
                    allowedPlacements={['bottom-start', 'top-start']}
                    anchor={({anchorRef, getAnchorProps}) => (
                        <Icon
                            ref={anchorRef}
                            {...getAnchorProps()}
                            type={Icons.CHAT}
                            size={Sizes.Size_14}
                        />
                    )}>
                    <Group className="pb-m">
                        <strong>AI Feedback</strong>
                    </Group>
                    <Group direction="v" gap="m">
                        <Group>
                            <Item>{camelToSnakeCase(fieldName)}</Item>
                            <CopyButton textToCopy={fieldName}/>
                        </Group>
                        <Separator/>
                        <Group direction="v" gap="xs">
                            <Group>
                                <strong>Summary:</strong>
                                <CopyButton textToCopy={summary}/>
                            </Group>
                            <Item>{summary}</Item>
                        </Group>
                        <FieldReviewList reviews={risks} caption="Risks:"/>
                        <FieldReviewList reviews={recommendations} caption="Recommendations:"/>
                    </Group>
                </Popover>
            ) : null}
        </>
    );
};
